import { render, staticRenderFns } from "./baseLoadingBar.vue?vue&type=template&id=c57530f0"
import script from "./baseLoadingBar.vue?vue&type=script&lang=js"
export * from "./baseLoadingBar.vue?vue&type=script&lang=js"
import style0 from "./baseLoadingBar.vue?vue&type=style&index=0&id=c57530f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports